// extracted by mini-css-extract-plugin
export default {"colorPicker":"styles_colorPicker__bnP3A"};